import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'diames'
})
export class DiaMesPipe implements PipeTransform {
  transform(value: string): string {
    return moment(value).utc(false).locale('pt-br').format('DD/MMM');
  }
}
